/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatMessage } from './ChatMessage';
import {
    ChatMessageFromJSON,
    ChatMessageFromJSONTyped,
    ChatMessageToJSON,
    ChatMessageToJSONTyped,
} from './ChatMessage';

/**
 * 
 * @export
 * @interface SendMessageResponse
 */
export interface SendMessageResponse {
    /**
     * 
     * @type {ChatMessage}
     * @memberof SendMessageResponse
     */
    userMessage: ChatMessage;
    /**
     * 
     * @type {ChatMessage}
     * @memberof SendMessageResponse
     */
    assistantMessage: ChatMessage;
}

/**
 * Check if a given object implements the SendMessageResponse interface.
 */
export function instanceOfSendMessageResponse(value: object): value is SendMessageResponse {
    if (!('userMessage' in value) || value['userMessage'] === undefined) return false;
    if (!('assistantMessage' in value) || value['assistantMessage'] === undefined) return false;
    return true;
}

export function SendMessageResponseFromJSON(json: any): SendMessageResponse {
    return SendMessageResponseFromJSONTyped(json, false);
}

export function SendMessageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendMessageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userMessage': ChatMessageFromJSON(json['userMessage']),
        'assistantMessage': ChatMessageFromJSON(json['assistantMessage']),
    };
}

export function SendMessageResponseToJSON(json: any): SendMessageResponse {
    return SendMessageResponseToJSONTyped(json, false);
}

export function SendMessageResponseToJSONTyped(value?: SendMessageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userMessage': ChatMessageToJSON(value['userMessage']),
        'assistantMessage': ChatMessageToJSON(value['assistantMessage']),
    };
}

